
import { GosInitListsType } from "../config";
import { SPListsFields, SPDataType } from "../types";

export type FetchOptions<K extends GosInitListsType> = {
  listName: K;
  viewFields?: Partial<Array<keyof SPListsFields[K]>>;
  rowLimit?: number;
};

export const getGosInitDataRequest = <K extends GosInitListsType>({
  listName,
}: FetchOptions<K>) => {
  return new Promise<{
    items: SPDataType[];
    listName: typeof listName;
    count: number;
  }>((resolve, reject) => {
    resolve({
      items: [],
      listName,
      count: 0,
    });
  });
};
